import { Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { NgIf } from '@angular/common';
import { LocalStorageService } from '@services/local-storage-service';

@Component({
  selector: 'more-insights-bottomsheet',
  templateUrl: './more-insights-bottomsheet.html',
  imports: [
    NgIf
  ],
  standalone: true
})
export class MoreInsightsBottomsheetComponent {
  fromSelfCheckupBanner: boolean = false;

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private readonly bottomSheetRef: MatBottomSheetRef,
    private readonly router: Router,
    private readonly localStorageService: LocalStorageService,
  ) { }

  ngOnInit(): void {
    if (this.data.fromSelfCheckupBanner) this.fromSelfCheckupBanner = this.data.fromSelfCheckupBanner;
  }

  skipChat(): void {
    this.closePopup();
    this.router.navigate(['/user'], { queryParams: { tab: 'home' } });
    this.localStorageService.delete('fromSelfCheckupBanner');
  }

  closePopup(): void {
    this.bottomSheetRef.dismiss();
    if (this.fromSelfCheckupBanner) this.router.navigate(['/user'], { queryParams: { tab: 'home' } });
  }

  navigateToChat(): void {
    this.bottomSheetRef.dismiss();
    const followUpId = this.data.followUpId || this.localStorageService.getValue('currentProgressFollowUpId');

    if (followUpId) {
      this.localStorageService.delete('currentProgressFollowUpId');
      this.router.navigate([`/chatV2/${followUpId}`], {
        queryParams: {type: 'followUp', fromSelfCaptureBanner: true},
      });
    } else {
      this.router.navigate(['/user'], { queryParams: { tab: 'home' } });
    }
    this.localStorageService.delete('fromSelfCheckupBanner');
  }
}
